import { useFetcher } from '../lib/fetch-hooks';

export function useCouponCode() {
  const { status, error, response, fetcher } = useFetcher();

  const createCoupon = ({ phone, coupon_code, name, discount_percent }) =>
    fetcher({
      method: 'post',
      isSecure: false,
      url: '/user/users/create-public-coupon',
      body: { phone, coupon_code, name, discount_percent },
    });

  return { createCoupon, status, error, response };
}
